<template>
  <div class="template-container">
    <div
      ref="navbarRef"
      :class="[
        'template-navbar',
        {
          'template-navbar__impersonate--enabled': isImpersonateFlag
        }
      ]"
    >
      <slot :is-navbar-transparent="isNavbarTransparent" name="navbar" />
    </div>
    <div class="template-container__hero">
      <slot name="hero" />
    </div>
    <div ref="contentRef" class="template-container__content">
      <slot name="content" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator';
import { throttle } from 'lodash-es';

import { isImpersonate } from '@/modules/common/services/partner';

@Component
export default class HeroContainer extends Vue {
  @Ref()
  private readonly navbarRef!: HTMLDivElement;

  @Ref()
  private readonly contentRef!: HTMLDivElement;

  private isNavbarTransparent = true;
  private removeOnScrollListener!: () => void;

  mounted() {
    const handleOnScroll = throttle(this.handleNavbarTransparency, 100);
    window.addEventListener('scroll', handleOnScroll);

    this.removeOnScrollListener = () =>
      window.removeEventListener('scroll', handleOnScroll);
  }

  destroyed() {
    this.removeOnScrollListener();
  }

  private handleNavbarTransparency() {
    const navbarHeight = this.navbarRef.getBoundingClientRect().height;
    const contentTop = this.contentRef.getBoundingClientRect().top;
    const isContentAtTop = contentTop >= navbarHeight;
    const shouldChangeNavbarColor = this.isNavbarTransparent !== isContentAtTop;

    if (shouldChangeNavbarColor) {
      this.isNavbarTransparent = isContentAtTop;
    }
  }

  get isImpersonateFlag() {
    return isImpersonate();
  }
}
</script>

<style lang="less" scoped>
@navbar-impersonate: 48px;

.template-navbar {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 10;

  &__impersonate--enabled {
    margin-top: @navbar-impersonate !important;
  }
}

.template-container {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__hero {
    position: sticky;
    top: 0;
  }

  &__content {
    display: flex;
    width: 100%;
    flex-direction: column;
    background: @background-secondary;
    position: relative;
    z-index: 10;
  }
}
</style>
